import React from "react";
import styled from "styled-components";
import { Icons } from "../../../hooks/useIcons";
import { eventDetails } from "../../../assets/data/event-page/eventPageData";
import StepsIndicator from "../../../utils/carousel-steps-indicator/StepsIndicator";

const IbadanEventsDetails = ({currentSlide, setCarouselCurrentSlide}) => {
  const { eventDateIcon, eventTimeIcon, teamsIcon } = Icons();
  const {ibadan} = eventDetails()

  return (
    <>
      <MainIconWrapper data-aos-once="true" data-aos="fade-up">
        <IconWrapper>
          <Icon src={eventTimeIcon} alt="time" />
          <IconText>{ibadan.time}</IconText>
        </IconWrapper>
        <IconWrapper>
          <Icon src={teamsIcon} alt="event-date" />
          <IconText>{ibadan.date}</IconText>
        </IconWrapper>
        <IconWrapper>
          <Icon src={eventDateIcon} alt="teams" />
          <IconText>{ibadan.venue}</IconText>
        </IconWrapper>
      </MainIconWrapper>
      <EventPosterWrapper>
        <EventPoster src={ibadan.flyerUrl} alt={"eventTitle"} />
      </EventPosterWrapper>

            <StepsIndicator
                currentSlide={currentSlide}
                setCarouselCurrentSlide={setCarouselCurrentSlide}
              />
    </>
  );
};

export default IbadanEventsDetails;

const MainIconWrapper = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  max-width:700px;
  @media (min-width: 476px) {
    @media (min-width: 476px) {
    gap: 20px;
  }
`;
const IconWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const IconText = styled.div`
  font-family: "Lato";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 200%;
  color: #a7a7a7;
  opacity: 0.9;
`;
const Icon = styled.img`
  width: 18px;
  height: 18px;
`;
const EventPoster = styled.img`
  width: 100%;
  max-width: 100%;
  height: auto;
  object-fit: contain;
  border-radius: 5px;
`;



const EventPosterWrapper = styled.div`
  width: 100%;
  margin: 30px 0;
`;